<template lang="pug">
  #app(:class="classes" v-if="account.id")
    #app-content
      drawer-menu
      div
        app-navbar(:sticky="sticky")
        router-view
    app-footer
</template>

<script>
import { mapGetters } from 'vuex';
import { Validator } from 'vee-validate';
import DrawerMenu from '@/components/DrawerMenu.vue';
import AppNavbar from '@/components/AppNavbar.vue';
import AppFooter from '@/components/AppFooter.vue';
import installRules from '@/utils/validators';
import * as getterTypes from '@/store/types/getters';

installRules(Validator);

export default {
  name: 'app',
  components: {
    AppFooter,
    AppNavbar,
    DrawerMenu,
  },
  computed: {
    ...mapGetters({
      account: getterTypes.GET_ACCOUNT,
    }),
    accountAbbreviation() {
      if (this.account.id !== undefined) {
        return this.account.abbreviation.toLowerCase();
      }
      return null;
    },
    classes() {
      return [
        this.accountAbbreviation,
        `${this.$route.name}-page`,
      ].join(' ');
    },
  },
  created() {
    document.title = process.env.VUE_APP_TITLE;
  },
  data() {
    return {
      sticky: false,
    };
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.sticky = window.scrollY > 46;
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
};
</script>

<style lang="scss">
  @import "~bulma";
  @import "~buefy/src/scss/buefy";
  @import "assets/styles.scss";
</style>

<style theme="cwo" lang="scss">
.content {
  a {
    @include link;
  }
}
</style>
